export default __webpack_public_path__ + "static/media/p-table.3ae0ae72.jpg";